import { EventType } from '@electron/shared/meetings.types';
import { useQueries } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';

import type { TimeSpan } from './calendarSnapshot';

const MAX_SNAPSHOT_EVENTS = 50;

// One query per day column, so two days far apart never fetch every day between them
export const useCalendarSnapshotEventsQueries = (spans: readonly TimeSpan[]) =>
  useQueries({
    queries: spans.map((span) => ({
      queryKey: [
        'calendar',
        'events',
        'snapshot',
        { timeMin: span.start.toISOString(), timeMax: span.end.toISOString() },
      ],
      queryFn: () =>
        backendApis.calendar.getEventsReport({
          timeMin: span.start.toISOString(),
          timeMax: span.end.toISOString(),
          maxEvents: MAX_SNAPSHOT_EVENTS,
          excludeSoloEvents: false,
          excludedEventTypes: [EventType.WorkingLocation, EventType.Birthday],
          excludedStatuses: ['cancelled'],
          includeAllDay: true,
        }),
      staleTime: 60_000,
      refetchInterval: 60_000,
    })),
  });
